import React, { useState } from 'react';
import * as s from './faq.module.less';
import * as landingPageStyle from '../landing-page.module.less';
import Pane from '../../pane/pane';
import PaneTitle from '../../pane/pane-title/pane-title';
import cn from 'classnames';

// Placeholder FAQ data - Fetch dynamically or expand later
const faqData = [
  {
    question: "Wieviel Zeit muss ich für das Prototyping einplanen?",
    answer: "Neben dem initialen Gespräch und dem Kickoff benötigen wir hauptsächlich für Feedbackschleifen und die finale Abnahme Ihre Zeit. Der reine Entwicklungsaufwand liegt bei uns. Rechnen Sie mit wenigen Stunden über den Projektverlauf verteilt."
  },
  {
    question: "Was kostet ein Prototyp und was ist enthalten?",
    answer: "Die Kosten variieren je nach Komplexität. Ein typischer Prototyp für eine Web- oder Mobile-App beinhaltet das Design, die Entwicklung der Kernfunktionen für einen Klick-Dummy und die finale Übergabe. Kontaktieren Sie uns für ein individuelles Angebot."
  },
  {
    question: "Welche Technologien verwenden Sie?",
    answer: "Wir sind flexibel und wählen die Technologie, die am besten zu Ihrem Projekt passt, egal ob Web (React, Vue, Angular), Mobile (React Native, Flutter) oder andere moderne Frameworks."
  },
  {
    question: "Ist der Prototyp später erweiterbar?",
    answer: "Ja, der Prototyp dient als solide Grundlage. Wir achten auf sauberen Code, sodass der Prototyp effizient zu einem vollwertigen Produkt weiterentwickelt werden kann."
  }
];

const FaqItem = ({ item, isOpen, onClick }) => {
  return (
    <div className={s.faqItem}>
      <button className={s.faqQuestion} onClick={onClick}>
        {item.question}
        <span className={cn(s.arrow, { [s.isOpen]: isOpen })}>{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <div className={s.faqAnswer}>
          <p>{item.answer}</p>
        </div>
      )}
    </div>
  );
};

const Faq = ({
  faqData,
  heading = "Häufig gestellte Fragen (FAQ)",
  description = "Antworten auf Ihre wichtigsten Fragen zum Prototyping.",
  backgroundColor,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Pane
      bgColor={backgroundColor}
    >
      <div className={landingPageStyle.container}>
        <PaneTitle title={heading} description={description} isCentered />
        <div className={s.faqContainer}>
          {faqData.map((item, index) => (
            <FaqItem
              key={index}
              item={item}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      </div>
    </Pane>
  );
};

export default Faq;
